import React from 'react'
import Hero from '../components/Hero/Hero'
import Highlights from './Highlights'

function Home() {
    return (
        <>
            <Hero/>
            <Highlights/>
        </>
    )
}

export default Home
